import styled from "styled-components";

const HeaderSearchOrganismWrapper = styled.div``;

export { HeaderSearchOrganismWrapper };
